module.exports = __webpack_public_path__ + "img/screen2.b1837f32.png";